// extracted by mini-css-extract-plugin
export default {"container":"WK-z","error":"XK-z","disabled":"YK-z","submit":"ZK-z","option":"_K-z","success":"aL-z","failure":"bL-z"};